export default __webpack_public_path__ + "static/media/8.ee425a4c.webp";